import { JsonObject, JsonProperty } from 'json2typescript';
import { AdvancedSearchInterface } from '../interfaces/advancedSearch.interface';
import { AdvancedSearchItemModel } from './advancedSearchItem.model';

@JsonObject('AdvancedSearchModel')
export class AdvancedSearchModel implements AdvancedSearchInterface {
  @JsonProperty('Assets', [AdvancedSearchItemModel])
  Assets: AdvancedSearchItemModel[];

  @JsonProperty('NumTotal', Number)
  NumTotal: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
